import * as React from 'react';
import { cn } from '@/lib/utils';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

/**
 * §9-Styleguide Input: flat-corner, Hairline-Border, Focus via avameo-Primary.
 *
 * Browser-Spinner bei `type="number"` werden global ausgeblendet:
 *  - WebKit (Chrome/Safari/Edge): `::-webkit-inner-spin-button` /
 *    `::-webkit-outer-spin-button` auf `appearance: none`
 *  - Firefox: `[type=number]` auf `appearance: textfield` (alias für "ohne
 *    Spinner"). Tailwind: `[&[type=number]]:[appearance:textfield]`
 *  Hintergrund: Die Pfeile fressen Platz auf der rechten Seite und schneiden
 *  bei text-right-Inputs (Menge / Einzelpreis / Skonto / Zahlungsziel) die
 *  Zahl visuell an. User kann weiter mit Pfeil↑/↓ und Mausrad inkrementieren.
 */
export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => (
    <input
      type={type}
      className={cn(
        'flex h-9 w-full border border-hair-strong bg-panel px-3 py-1.5 text-sm text-ink',
        'file:border-0 file:bg-transparent file:text-sm file:font-medium',
        'placeholder:text-ink-muted',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-avameo-primary focus-visible:ring-offset-1 focus-visible:border-avameo-primary',
        'disabled:cursor-not-allowed disabled:bg-bg-alt disabled:text-ink-muted',
        '[&[type=number]]:tabular-nums',
        // Spinner-Pfeile bei type="number" verstecken (siehe JSDoc oben)
        '[&[type=number]]:[appearance:textfield]',
        '[&[type=number]::-webkit-inner-spin-button]:appearance-none',
        '[&[type=number]::-webkit-inner-spin-button]:m-0',
        '[&[type=number]::-webkit-outer-spin-button]:appearance-none',
        '[&[type=number]::-webkit-outer-spin-button]:m-0',
        className,
      )}
      ref={ref}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
